export default function WallOfLoveListSkeleton() {
	return (
		<div className="space-y-2">
			{Array.from({ length: 5 }).map((_, index) => (
				<div key={index} className="flex items-center justify-between p-4 bg-white rounded-xl border border-gray-200 animate-pulse">
					{/* Left: Icon, Title and metadata */}
					<div className="flex items-center gap-4 min-w-0 flex-1">
						{/* Icon skeleton */}
						<div className="w-10 h-10 rounded-lg bg-gray-200 flex-shrink-0"></div>

						{/* Title and meta skeleton */}
						<div className="min-w-0">
							<div className="h-4 w-32 bg-gray-200 rounded mb-2"></div>
							<div className="flex items-center gap-3">
								<div className="h-3 w-24 bg-gray-200 rounded"></div>
								<div className="h-3 w-1 bg-gray-200 rounded"></div>
								<div className="h-3 w-16 bg-gray-200 rounded"></div>
							</div>
						</div>
					</div>

					{/* Right: Actions skeleton */}
					<div className="flex items-center gap-1">
						<div className="h-7 w-20 bg-gray-200 rounded-md"></div>
						<div className="w-px h-5 bg-gray-200 mx-1"></div>
						<div className="h-7 w-20 bg-gray-200 rounded-md"></div>
						<div className="h-7 w-16 bg-gray-200 rounded-md"></div>
						<div className="h-7 w-7 bg-gray-200 rounded-md"></div>
					</div>
				</div>
			))}
		</div>
	);
}

